var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.754 16.078c0-7.087-5.71-12.832-12.754-12.832S3.246 8.991 3.246 16.078c0 6.405 4.664 11.713 10.761 12.676v-8.967H10.77v-3.709h3.238v-2.827c0-3.216 1.904-4.992 4.817-4.992 1.396 0 2.855.25 2.855.25v3.158h-1.608c-1.584 0-2.078.99-2.078 2.004v2.407h3.537l-.566 3.71h-2.971v8.966c6.097-.963 10.76-6.271 10.76-12.676z",
    fill: "#fff"
  })));
}
export default SvgFacebook;